import { render } from "./couponSvg.vue?vue&type=template&id=2f8b7a62&scoped=true"
import script from "./couponSvg.vue?vue&type=script&lang=js"
export * from "./couponSvg.vue?vue&type=script&lang=js"

import "./couponSvg.vue?vue&type=style&index=0&id=2f8b7a62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8b7a62"]])

export default __exports__